/* eslint-disable react/state-in-constructor */
import config from 'config';
import debug from 'debug';
import PropTypes from 'prop-types';
import React from 'react';
import { Search } from '@mulesoft/exchange-search-components';
import { ANGFilters } from '@mulesoft/exchange-search-common';
import * as constants from '~/utils/ang/constants';
import styles from './ANGSearch.css';

const log = debug('exchange:ang-search:component');

const searchFilters = [
  'types',
  'organizations',
  'categories',
  'tags',
  'statuses',
  'customFields'
];

class ANGSearch extends React.PureComponent {
  static propTypes = {
    boostConfiguration: PropTypes.arrayOf(PropTypes.object),
    defaultSort: PropTypes.string,
    onSearch: PropTypes.func,
    onResultsChange: PropTypes.func,
    onFacetsChange: PropTypes.func,
    sort: PropTypes.string,
    usePlatformSearch: PropTypes.bool,
    filters: PropTypes.instanceOf(ANGFilters).isRequired
  };

  static defaultProps = {
    onSearch: () => {},
    usePlatformSearch: false
  };

  constructor(props) {
    super(props);
    this.searchRef = React.createRef();

    const { filters } = props;

    let preJsText = '';

    if (typeof window !== 'undefined' && window.sessionStorage) {
      preJsText = sessionStorage.getItem('preJsSearchText') || '';
      sessionStorage.removeItem('preJsSearchText');
      const query = filters.getQuery?.();

      if (preJsText && query && typeof query === 'object' && !query.search) {
        query.search = preJsText;
      }
    }

    this.state = {
      angFilters: filters,
      prevANGFilters: props.filters
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.prevANGFilters !== props.filters) {
      return {
        prevANGFilters: props.filters,
        angFilters: props.filters
      };
    }

    return null;
  }

  handleReady = () => {
    this.searchRef?.current?.search();
  };

  handleChange = (angFilters) => {
    this.setState({
      angFilters
    });
  };

  handleFacetsChange = (facets) => {
    this.props.onFacetsChange(facets);
  };

  handleSearch = (angFilters, angState, angConfig, sort) => {
    const { onSearch } = this.props;

    return onSearch(angFilters, sort);
  };

  render() {
    const {
      boostConfiguration,
      defaultSort,
      sort,
      usePlatformSearch,
      onResultsChange
    } = this.props;
    const { angFilters } = this.state;

    log('using state', angFilters.getQuery());

    return (
      <div className={styles.search}>
        <Search
          angFilters={angFilters}
          ref={this.searchRef}
          onFiltersChange={this.handleChange}
          onFacetsChange={this.handleFacetsChange}
          sort={sort}
          sortOnClear={defaultSort}
          boostConfiguration={boostConfiguration}
          maxResults={
            usePlatformSearch
              ? config.maxPseasStreamSearchResults
              : constants.MAX_ANG_STREAM_SEARCH_RESULTS
          }
          filters={searchFilters}
          onSearch={this.handleSearch}
          onResultsChange={onResultsChange}
          onReady={this.handleReady}
          usePlatformSearch={usePlatformSearch}
          placeholder="Search assets"
        />
      </div>
    );
  }
}

export default ANGSearch;
